export default __webpack_public_path__ + "static/media/camp.b73db048.jpg";